import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useMissingPersons(options) {
  const searchParams = JSON.parse(JSON.stringify(options ?? {}));

  return useQuery({
    queryKey: ['missingPersons', searchParams],
    queryFn: () => {
      return briefingApi
        .get('niche/missingPersons', { searchParams, timeout: false })
        .json();
    },
    placeholderData: [],
    staleTime: 110 * (60 * 1000), // only refetch 110 minutes
    cacheTime: 120 * (60 * 1000), // keep data in cache for for two hour
  });
}
